"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACK_KEY = void 0;
exports.TRACK_KEY = {
    GOOGLE_AUTH_BUTTON_CLICK: 'googleAuthButtonClick',
    GOOGLE_AUTH_ONE_TAP_CLICK: 'googleAuthOneTapClick',
};
